// @core/api/endpoints/team/delete_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Delete role schedule
 * Permanently deletes the specified role schedule.
 */
export async function DeleteRoleSchedule(
  team_id: string,
  schedule_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
